import { Component, HostBinding, Input } from '@angular/core';
import { AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-text-area',
    templateUrl: './text-area.component.html',
    standalone: true,
    imports: [
        NgIf,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
    ],
})
export class TextAreaComponent {
    @Input() placeholder: string;
    @Input() control: AbstractControl;
    @Input() required = false;
    @Input() maxLength;
    @Input() id = '';
    @Input() autocomplete = 'off';
    @Input() type = 'search';
}
